
import { defineComponent, ref, computed, onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import ApiService from "@/core/services/ApiService";
import Multiselect from "@vueform/multiselect";
import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default defineComponent({
  name: "MasterInvoice",
  components: {
    Loading,
    Multiselect,
  },
  watch: {
    invoiceType: {
      handler(newVal) {
        this.fetchInvoices(this.paging.size, this.paging.page);
      },
      immediate: true,
    },
    invoicesettingId: {
      handler(newVal) {
        this.fetchInvoices(this.paging.size, this.paging.page);
      },
      immediate: true,
    },
  },
  setup() {
    const router = useRouter();
    const invoices = <any>ref([]);
    const searchQuery = ref("");
    const filterStatus = ref("");
    const invoiceType = ref("");
    const schoolId = ref(""); // Assuming you have a way to set this
    const paymentStatus = ref(""); // Assuming you have a way to set this
    const isLoading = ref(false);
    const schoolSelected = ref(false);
    const schoolName = ref("");
    const ListSchool = ref([]);
    const loadingComboSchool = ref(false);
    const timerComboSchool = ref(0);
    const role = ref("");
    const invoiceSettingList = <any>ref([]);
    const invoicesettingId = ref("");
    const paging = ref({
      page: 0,
      totalPages: 0,
      size: 10,
      totalElements: 0,
      perPageOptions: [10, 25, 50, 100],
    });

    const fetchInvoices = async (size, page) => {
      try {
        isLoading.value = true;
        let query: any = [];
        if (schoolId.value) query.push(`schoolId=${schoolId.value}`);
        if (invoicesettingId.value)
          query.push(`invoicesettingId=${invoicesettingId.value}`);
        if (invoiceType.value) query.push(`invoiceType=${invoiceType.value}`);
        query.push(`page=${page}`);
        query.push(`size=${size}`);
        query.push(`sort=updateTime`);
        query.push(`dir=-1`);
        const response = await ApiService.getWithoutSlug(
          `crmv2/main_invoice/invoice/office/invoice/master/all?${query.join(
            "&"
          )}`
        );
        invoices.value = response.data.content;
        paging.value.page = response.data.page;
        paging.value.totalPages = response.data.totalPages;
        paging.value.size = response.data.size;
        paging.value.totalElements = response.data.totalElements;
      } catch (error: any) {
        console.error(
          "Error fetching invoices:",
          error.response.data.detail || error.response.data.message
        );
      } finally {
        isLoading.value = false;
      }
    };

    const getListInvoiceSetting = () => {
      ApiService.getWithoutSlug(
        `crmv2/main_invoice/invoice/office/invoice/settings/combo_inv_setting`
      ).then(({ data }) => {
        invoiceSettingList.value = data;
      });
    };

    const pilihInvoiceType = (event) => {
      invoiceType.value = event;
      fetchInvoices(paging.value.size, paging.value.page);
    };

    const filteredInvoices: any = computed(() => {
      return invoices.value.filter((invoice: any) => {
        const matchesSearch = invoice.number.includes(searchQuery.value);
        const matchesStatus = filterStatus.value
          ? invoice.status === filterStatus.value
          : true;
        return matchesSearch && matchesStatus;
      });
    });

    const from = computed(() => {
      return paging.value.size * paging.value.page;
    });

    const to = computed(() => {
      let highBound = from.value + paging.value.size;
      if (paging.value.totalElements < highBound) {
        highBound = paging.value.totalElements;
      }
      return highBound;
    });

    const navigateToAddInvoice = () => {
      router.push("/superadmin/master-invoice/add");
    };

    const editInvoice = (id) => {
      router.push(`/superadmin/master-invoice/edit/${id}`);
    };

    const deleteInvoice = async (id) => {
      try {
        await ApiService.delete(
          `crmv2/main_invoice/invoice/office/invoice/master/delete/${id}`
        );
        fetchInvoices(paging.value.size, paging.value.page); // Refresh the invoice list after deletion
      } catch (error: any) {
        console.error(
          "Error deleting invoice:",
          error.response.data.detail || error.response.data.message
        );
      }
    };

    const pilihSekolah = (event) => {
      var namaSekolah = "";
      schoolId.value = "";
      schoolSelected.value = false;
      localStorage.removeItem("sekolahIdMenuInvoice");
      if (event) {
        schoolId.value = event;
        schoolSelected.value = true;
        localStorage.setItem("sekolahIdMenuInvoice", event);
        let school: any = ListSchool.value.find(
          (item: any) => item.id == schoolId.value
        );
        namaSekolah = school.name;
        schoolName.value = school.name;
      }
      localStorage.setItem("schoolName", namaSekolah);
      localStorage.setItem("sekolahId", schoolId.value);
      fetchInvoices(paging.value.size, paging.value.page);
    };

    const cari = (val) => {
      clearTimeout(timerComboSchool.value); //this timer 0 - set 0 atau clear jika ada input lagi
      loadingComboSchool.value = true;
      timerComboSchool.value = setTimeout(() => {
        getListSchool(val);
      }, 1000);
    };

    const getListSchool = (name = "") => {
      let list = JSON.parse(localStorage.getItem("listSchool")!);
       if (list && list.length > 0) {
        ListSchool.value = list;
        return;
      }
      loadingComboSchool.value = true;
      ApiService.getWithoutSlug(
        `crmv2/main_invoice/invoice/office/invoice/combo/school?name=${name}&limit=2000`
      ).then(({ data }) => {
        loadingComboSchool.value = false;
        ListSchool.value = data;
        localStorage.setItem("listSchool", JSON.stringify(data));
      });
    };

    const changePage = (item) => {
      const page = item - 1;
      fetchInvoices(paging.value.size, page);
    };
    const nextPage = () => {
      const page = paging.value.page + 1;
      fetchInvoices(paging.value.size, page);
    };
    const prevPage = () => {
      const page = paging.value.page - 1;
      fetchInvoices(paging.value.size, page);
    };
    const changePageSize = () => {
      const page = paging.value.page;
      fetchInvoices(paging.value.size, page);
    };

    const range = (min, max) => {
      const arr: any[] = [];
      for (let i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    };

    onBeforeMount(() => {
      store.dispatch(Actions.VERIFY_AUTH_FINANCE);
      role.value = JSON.parse(localStorage.getItem("user_account")!).role;
      schoolId.value = localStorage.getItem("sekolahId") || "";
      schoolName.value = localStorage.getItem("schoolName") || "";
      if (schoolName.value) getListSchool(schoolName.value);
      const storedSchoolId = localStorage.getItem("sekolahIdMenuInvoice");
      if (storedSchoolId) {
        schoolId.value = storedSchoolId;
        schoolSelected.value = true;
      }
      getListInvoiceSetting();
      getListSchool();
      fetchInvoices(paging.value.size, paging.value.page);
    });

    return {
      Multiselect,
      invoices,
      searchQuery,
      filterStatus,
      filteredInvoices,
      schoolId,
      paymentStatus,
      paging,
      isLoading,
      schoolSelected,
      schoolName,
      ListSchool,
      loadingComboSchool,
      invoiceType,
      invoiceSettingList,
      invoicesettingId,
      from,
      to,
      changePageSize,
      changePage,
      prevPage,
      nextPage,
      range,
      fetchInvoices,
      navigateToAddInvoice,
      editInvoice,
      deleteInvoice,
      pilihSekolah,
      pilihInvoiceType,
      cari,
    };
  },
});
